import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AuthService } from '../../services/auth';
import { RouterLink, RouterLinkActive  } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';



@Component({
  selector: 'app-header',
  imports: [MatToolbarModule, CommonModule,RouterLink, RouterLinkActive, MatIcon,MatIconModule,MatButtonModule,
    MatTooltip
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
    standalone: true,

})
export class Header {

  isLoggedIn;
  isMobileMenuOpen = false;
  userName;
  user;
  navLinks = [
    { title: 'Home', page: '/dashboard', icon: 'home' },
    { title: 'Conversations', page: '/conversation', icon: 'chat' }, // Adjusted to current route
    { title: 'Settings', page: '/settings', icon: 'settings' }, // Adjusted to current route
    { title: 'Insights', page: '/insights', icon: 'dashboard' }
  ];

  constructor(private authService: AuthService) {
   this.isLoggedIn = this.authService.isLoggedIn();
   this.authService.user$.subscribe(user=>{
    if(user){
      this.user = user;
      this.userName = user.email;
    }
   })
  }



  // logout() {
  //   this.authService.logout();
  // }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  logout() {
    this.authService.logout();
    this.closeMobileMenu(); // Close menu on logout
  }
  

  openProfileMenu(event: MouseEvent): void {
  // Placeholder for now — you can open a MatMenu or dialog here later
  console.log('Profile menu clicked', event);
  // this.dialog.open(ProfileDialogComponent);
}
}
